const legacyPrivateCacheNames = ['api-cache', 'supabase-cache']

export default defineNuxtPlugin(async () => {
  if (!('caches' in window)) return

  await Promise.all(
    legacyPrivateCacheNames.map((cacheName) => window.caches.delete(cacheName)),
  )
})
